module.exports = __webpack_public_path__ + "static/media/artemis.ec9b98a3.jpg";